
import "/app/src/components/RightContent/index.less?modules";
export default {"search": `search-0hVncIDy`,"account": `account-42bU9Ph2`,"avatar": `avatar-4cHRGrZP`,"menu": `menu-mY4kQfmc`,"right": `right-Cz148o78`,"action": `action-5NceMqoF`}
